import { useEffect, useState } from 'react';
import { ManagementViewKpis } from '../../../shared/types/managementViewKpi.ts';
import { ModalDialog } from '../../components/modalDialog.tsx';
import { trpc } from '../../utils/trpc/trpc.ts';


interface Props {
    managementViewKpis: ManagementViewKpis;
    onPriceSubmitted: (partName: string, price: number) => void;
    onClose: () => void;
}

export function PriceDialog({
    managementViewKpis,
    onPriceSubmitted,
    onClose,
}: Props) {

    const [price, setPrice] = useState<string>('');


    useEffect(() => {
        setPrice((managementViewKpis.pricePerPart ?? '').toString())
    }, [managementViewKpis]);

    const mutatePrice = trpc.products.setPrice.useMutation();


    async function handleSubmit(event: React.FormEvent<HTMLFormElement>) {
        event.preventDefault();
        if (!managementViewKpis) return;

        const priceParsed = price ? parseFloat(price) : null;
        if (!priceParsed) {
            alert('Invalid price');
            return;
        }

        try {
            await mutatePrice.mutateAsync({
                partName: managementViewKpis.partName!,
                product: managementViewKpis.product!,
                price: priceParsed,
            });

            onPriceSubmitted(managementViewKpis.partName!, priceParsed);
            onClose();
        } catch (error) {
            console.error('Error updating price:', error);
            alert('Failed to update price');
        }
    }


    if (!managementViewKpis) return null;
    return (
        <ModalDialog
            frameStyle={{ minWidth: '360px' }}
            isOpen={true}
            onCancel={onClose}
        >
            <div>Set new price for {managementViewKpis.partName}</div>

            <form onSubmit={handleSubmit}>
                <div className='dialog-form__field--with-margins' >
                    <input
                        className='dialog-form__input'
                        name='price'
                        type={'number'}
                        step={0.01}
                        min={0}
                        value={price}
                        onChange={e => setPrice(e.target.value)}
                    />
                </div>

                <div className='dialog--button-bar'>
                    <button type='button' onClick={onClose}>Cancel</button>
                    <button type='submit' disabled={mutatePrice.isPending}>
                        {mutatePrice.isPending ? 'Submitting...' : 'Submit'}
                    </button>
                </div>
            </form>
        </ModalDialog >
    )
}
